export default __webpack_public_path__ + "static/media/contacts.7a541cb4.svg";